import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MaintenanceStrategyAttribute } from '../../../viewmodels/maintenance-strategies/maintenance-strategy-attribute';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceStrategyAttributesService {
  private subjectAddingAttribute = new Subject<MaintenanceStrategyAttribute>();
  private subjectEditingAttribute = new Subject<MaintenanceStrategyAttribute>();
  private subjectDeletedAttributes = new Subject<MaintenanceStrategyAttribute[]>();
  private subjectAcceptedAddedAttribute = new Subject<MaintenanceStrategyAttribute>();
  private subjectAcceptedEditedAttribute = new Subject<MaintenanceStrategyAttribute>();
  private subjectShowDialog = new Subject();

  public addingAttribute = this.subjectAddingAttribute.asObservable();
  public editingAttribute = this.subjectEditingAttribute.asObservable();
  public deletedAttributes = this.subjectDeletedAttributes.asObservable();
  public acceptedAddedAttribute = this.subjectAcceptedAddedAttribute.asObservable();
  public acceptedEditedAttribute = this.subjectAcceptedEditedAttribute.asObservable();
  public showDialog = this.subjectShowDialog.asObservable();

  constructor() {}

  public requestAddAttribute(attribute: MaintenanceStrategyAttribute = null): void {
    this.subjectShowDialog.next();
    this.subjectAddingAttribute.next(attribute || this.createDefaultAttribute());
  }

  public requestEditAttribute(attribute: MaintenanceStrategyAttribute): void {
    this.subjectShowDialog.next();
    this.subjectEditingAttribute.next(attribute);
  }

  public deleteAttributes(deletedAttributes: MaintenanceStrategyAttribute[]): void {
    this.subjectDeletedAttributes.next(deletedAttributes);
  }

  public acceptAddedAttribute(acceptedAttribute: MaintenanceStrategyAttribute): void {
    this.subjectAcceptedAddedAttribute.next(acceptedAttribute);
  }

  public acceptEditedAttribute(acceptedAttribute: MaintenanceStrategyAttribute): void {
    this.subjectAcceptedEditedAttribute.next(acceptedAttribute);
  }

  private createDefaultAttribute(): MaintenanceStrategyAttribute {
    return new MaintenanceStrategyAttribute();
  }
}
